import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=81211f26&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=81211f26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81211f26",
  null
  
)

export default component.exports